export function CustomNoRowsOverlay({textToDisplay = "No rows to display"}) {
    return (
        <div style={{textAlign: "center", padding: "1em"}}>
            {textToDisplay}
        </div>
    );
}